module.exports = __webpack_public_path__ + "img/do_need_insurance.5a0e62ec.jpg";